const routes = [
    {
        path: "/graduation/clearance/form",
        component: () => import("../pages/graduationForm"),
        meta: {
            isAuthenticated: true,
        },
    },
];

export default routes;
